import React from "react";

const WalletConnect = ({ walletAddress, onConnect, onDisconnect, network }) => {
  const networkName = network ? network.name : '';
  return (
    <div>
      {walletAddress ? (
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <div style={{ color: "#F5C13E", fontWeight: "bold" }}>
            Connected to {networkName}: {walletAddress.substring(0, 6)}...
            {walletAddress.substring(walletAddress.length - 4)}
          </div>
          <button onClick={onDisconnect} className="disconnect-wallet-button">Disconnect Wallet</button>
        </div>
      ) : (
        <button onClick={onConnect} className="connect-wallet-button">Connect Wallet</button>
      )}
    </div>
  );
};

export default WalletConnect;